export default __webpack_public_path__ + "static/media/incident_responder.5eb4c56b.png";